import { CONSTANT } from "../utils/Constant";
import UrlBase from "../url/Urls";

const createUrl = (url, portal) => {
    let customUrl = "";

    switch (portal) {
        case CONSTANT.PORTAL_DD:
            customUrl = UrlBase.dd_base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
        case CONSTANT.PORTAL_GL:
            customUrl = UrlBase.base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
        case CONSTANT.PORTAL_OP:
            customUrl = UrlBase.op_base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
        case CONSTANT.PORTAL_SM:
            customUrl = UrlBase.sm_base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
        case CONSTANT.PORTAL_AT:
            customUrl = UrlBase.at_base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
        case CONSTANT.PORTAL_PP:
            customUrl = UrlBase.pp_base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
        default:
            customUrl = UrlBase.base_url + process.env.REACT_APP_API_CONTEXT + url;
            break;
    }
    return customUrl;
};

export default createUrl;
